// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Logo_logoWrapper__uIl22","logo":"Logo_logo__1bkWf","subtitle":"Logo_subtitle__ZsrOW"};